import { X } from "lucide-react";
import { cn } from "@/lib/utils";

// Reusable active-filter summary (ContentOS Collection Standard). `chips` is
// [{ key, label, onRemove }]. Renders nothing when there are no active filters.
export function FilterChips({ chips, onClearAll, className }) {
  if (!chips || chips.length === 0) return null;
  return (
    <div className={cn("flex flex-wrap items-center gap-1.5", className)} data-testid="collection-filter-chips">
      {chips.map((c) => (
        <span key={c.key} className="inline-flex items-center gap-1 rounded-full border border-border/70 bg-muted/40 py-0.5 pl-2.5 pr-1 text-[12px] text-foreground" data-testid={`filter-chip-${c.key}`}>
          <span className="text-muted-foreground">{c.label}</span>
          <button onClick={c.onRemove} aria-label={`Remove ${c.label}`} data-testid={`filter-chip-remove-${c.key}`}
            className="rounded-full p-0.5 text-muted-foreground hover:bg-muted hover:text-foreground">
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      <button onClick={onClearAll} data-testid="collection-clear-filters" className="ml-1 text-[12px] font-medium text-accent hover:underline">
        Clear all
      </button>
    </div>
  );
}
